import React, { useState } from 'react';
import './ToggleButton.scss'; // Import your CSS file for styling
import { useEffect } from 'react';

/**
 * ToggleButton Component
 * 
 * A switch-like toggle button that allows users to turn a state on or off.
 * The component's initial state is determined by the `accountStatus` prop and updates when it changes.
 * Clicking the button toggles its state and calls the `onChange` function passed as a prop.
 * 
 * @component
 * @memberof Components
 * 
 * @param {Object} props - React component props.
 * @param {boolean} props.accountStatus - The initial status of the toggle button (on/off).
 * @param {Function} props.onChange - Callback function to handle the toggle change event.
 * 
 * @returns {JSX.Element} A toggle switch UI component.
 * 
 * @example
 * // Basic usage
 * <ToggleButton accountStatus={true} onChange={() => console.log('Toggled!')} />
 */
function ToggleButton(props) {
  const [isOn, setIsOn] = useState(false);
  const { accountStatus } = props

  useEffect(() => {
    setIsOn(accountStatus)
  }, [accountStatus])

  /**
 * Toggles the switch state between on and off.
 */
  const toggleSwitch = () => {
    if (isOn) {
      setIsOn(false);
    }
    else {
      setIsOn(true);
    }
  };

  return (
    <div className={`toggle-button ${isOn ? 'on' : 'off'}`} onClick={() => {
      props.onChange()
      toggleSwitch()
    }}>
      <div className="circle" />
    </div>
  );
}

export default ToggleButton;